// Favorites Actions Types
export const SET_FAVORITES = 'SET_FAVORITES';

export const ADD_FAVORITE = 'ADD_FAVORITE';

export const REMOVE_FAVORITE = 'REMOVE_FAVORITE';

export const SET_FAVORITES_SEARCH = 'SET_FAVORITES_SEARCH';

// Theme Action Types
export const SWITCH_THEME = 'SWITCH_THEME';

// Movie Modal Types
export const OPEN_MOVIE_MODAL = 'OPEN_MOVIE_MODAL';

export const CLOSE_MOVIE_MODAL = 'CLOSE_MOVIE_MODAL';

// Search Types
export const SET_SEARCH_MOVIES_DATA = 'SET_SEARCH_MOVIES_DATA';

export const SWITCH_SEARCH_MODE = 'SWITCH_SEARCH_MODE';

export const SET_SEARCH_TEXT = 'SET_SEARCH_TEXT';

export const RESET_SEARCH_DATA = 'RESET_SEARCH_DATA';

// Fetching Loader Types
export const SWITCH_FETCHING_LOADER_STATE = 'SWITCH_FETCHING_LOADER_STATE';